<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users-cog"></i> Movimentação de Associados - Clusterização</h3>
      </div>
    </div>

    <Forms ref="frmGroup"
      :title="'MOVIMENTAÇÃO DE ASSOCIADOS'"
      :showSaveButton="true"
      v-on:Save="openConfirmationModal">
      <div class="form-group row justify-content-around">
        <div class="col-md-4">
          <label><small v-show="form.paId.required" class="text-danger">*</small> PA:</label>
          <div class="input-group">
            <v-select v-model="form.paId.value"
                        :options="form.paId.options"
                        class="w-100"
                        label="text"
                        :reduce="(opt) => opt.value"
                        @input="onSearch">
              <template v-slot:no-options>Nenhum pa encontrado.</template>
            </v-select>
          </div>
      </div>

      <div class="col-md-4 pb-3">
          <label><small v-show="form.clusterId.required" class="text-danger">*</small> Clusters:</label>
          <div class="input-group">

            <v-select v-model="form.clusterId.value"
                      :options="form.clusterId.options"
                      class="w-100"
                      label="text"
                      :reduce="(opt) => opt.value">
              <template v-slot:no-options>Nenhum Cluster encontrado.</template>
            </v-select>
          </div>
      </div>

      </div>

      <div class="form-group row pt-3">
        <div class="col-md-4">
          <div class="input-group">
            <b-form-input type="text"
              :placeholder="'Digite a Busca'"
              :disabled="allSelected"
              v-model="searchValue"
              @keyup.enter.stop="onSearch"></b-form-input>
              <span class="input-group-addon" @click="onSearch"><i class="fas fa-search"></i></span>
          </div>
        </div>
      </div>
      <!-- <div class="row justify-content-start">
        <div class="col-md-3 pb-2 pt-2">
          <div class="input-group">
            <b-form-input type="text"
                            :placeholder="'Digite a busca'"
                            v-model="searchValue">
            </b-form-input>
          </div>
        </div>
      </div> -->
      <div id="associate-list" style="overflow-y: auto; max-height:70vh;">
        <table  class="table table-hover" style="border: 1px solid #dcdede;" >
          <thead class="thead-third" style="border: solid 1px #0277bd; height: 44px;">
            <tr>
                <th class="text-center col-1"><input type="checkbox" v-model="selectAll" v-if="!searchValue"></th>
                <th class="text-center">Nome</th>
                <th class="text-center">Numero Sisbr</th>
                <th class="text-center">Cluster</th>
            </tr>
          </thead>
          <tr v-for="associado in associados" :key="associado.id">
            <td v-if="allSelected" class="text-center col-1"><input v-model="allSelected" type="checkbox" checked disabled/></td>
            <td v-else class="text-center col-1"><input v-model="selected" :value="associado.id" type="checkbox"/></td>
            <td class="text-center">{{associado.nome}}</td>
            <td class="text-center">{{associado.numSisbr}}</td>
            <td class="text-center">{{associado.clusterAtual}}</td>
          </tr>
        </table>
      </div>
      <AssociatePagination  ref="AssociatePagination" @LoadPage="LoadPage" class="pt-3"></AssociatePagination>
      <AddConfirmation ref="AddConfirmationModal"
                       :warnText="`Confirmar movimentação de  ${allSelected ? 'todos':this.selected.length} associados? `"
                       :saveFunction="updateClusters"/>
    </Forms>
  </div>
  </template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import LinkForm from './link-form'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'

import PARepository from '@/shared/http/repositories/configurations/pa'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster'
import AssociatePagination from '@/views/private/associate/pagination/associatepagination.vue'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'

const dataModel = {
  clusterId: null,
  paId: null
}

export default {
  name: 'linkClusters',
  mixins: [ActionsForm],
  data () {
    return {
      warnMessage: '',
      title: '',
      form: LinkForm,
      data: dataModel,
      selected: [],
      searchValue: '',
      associados: [],
      pageLimit: 50,
      pageIndex: 0,
      currentPage: 0,
      totalElements: 0,
      numberOfElementsDisplayed: 0,
      offset: 0,
      allSelected: false
    }
  },
  components: {
    AssociatePagination,
    AddConfirmation
  },
  computed: {
    selectAll: {
      get: function () {
        return this.allSelected
      },
      set: function () {
        if (this.allSelected) {
          this.allSelected = false
        } else {
          this.allSelected = true
        }
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      this.$refs.AssociatePagination.pageLimit = this.pageLimit
      this.$refs.AssociatePagination.totalElements = this.totalElements

      ClusterRepository.GetAll()
        .then((res) => {
          this.form.clusterId.options = res.data.content.map((x) => ({'value': x.id, 'text': x.descricao}))
          loading.pop()
        })
        .catch(this.onException)

      loading.push()
      PARepository.GetAll()
        .then((res) => {
          this.form.paId.options = res.data.content.map((x) => ({'value': x.id, 'text': x.numero + ' - ' + x.descricao}))
          loading.pop()
        })
        .catch(this.onException)
    },
    loadAssociadosPa () {
      loading.push()
      if (this.form.paId.value !== null) {
        AssociateRepository.GetAllInPa(this.form.paId.value, this.searchValue, this.pageLimit, this.pageIndex)
          .then((res) => {
            this.associados = res.data.content.map((x) => ({'id': x.id, 'nome': x.pessoa.nome, 'numSisbr': x.numSisbr, 'clusterAtual': x.clusterizacaoDTO ? x.clusterizacaoDTO.descricao : ''}))
            this.$refs.AssociatePagination.totalPages = res.data.totalPages
            this.$refs.AssociatePagination.totalElements = res.data.totalElements
            this.$refs.AssociatePagination.numberOfElementsDisplayed = res.data.numberOfElements
            this.$refs.AssociatePagination.offset = res.data.pageable.offset

            loading.pop()
          })
          .catch(this.onException)
        // AssociateRepository.GetAllNotInCluster(this.form.paId.value, this.searchValue, this.pageLimit, this.pageIndex)
        //   .then((res) => {
        //     this.associadosNotInCluster = res.data.content.map((x) => ({'id': x.id, 'nome': x.pessoa.nome, 'numSisbr': x.numSisbr}))
        //     this.$refs.AssociatePagination.totalPages = res.data.totalPages
        //     loading.pop()
        //   })
        //   .catch(this.onException)
      } else {
        loading.pop()
        this.associados = []
        this.selected = []
      }
    },
    onSearch () {
      if (!this.allSelected) {
        this.onClearPaging()
        this.LoadPage(this.pageIndex)
      }
    },
    onClearPaging () {
      this.currentPage = 0
      this.pageIndex = 0
      this.$refs.AssociatePagination.currentPage = this.currentPage
      this.$refs.AssociatePagination.pageIndex = this.pageIndex
      this.$refs.AssociatePagination.totalElements = this.totalElements
      this.$refs.AssociatePagination.numberOfElementsDisplayed = this.numberOfElements
      this.$refs.AssociatePagination.offset = this.offset
    },
    updateClusters () {
      if (!Tools.ValidateForms(this.form, this.data, this, toast)) {
        toast.warning('Erro atualizar cluster')
        return
      }
      if (this.allSelected) {
        this.data.associadoId = []
      } else {
        if (this.selected.length < 1) {
          toast.warning('Nenhum associado selecionado')
          return
        }
        this.data.associadoId = this.selected
      }
      loading.push()
      AssociateRepository.updateAllCluster(this.data)
        .then(() => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.reloadPage()
        })
        .catch(this.onException)
    },
    reloadPage () {
      this.selected = []
      this.searchValue = ''
      this.associados = []
      this.onSearch()
    },
    LoadPage (index) {
      this.currentPage = index
      this.pageIndex = index
      if (this.searchValue !== null && this.searchValue !== '') {
        this.loadAssociadosPaWithFilter()
      } else {
        this.loadAssociadosPa()
      }
      var obj = document.getElementById('associate-list')
      obj.scrollTo(0, 0)
      // window.scrollTo(0, 0)
    },
    loadAssociadosPaWithFilter () {
      loading.push()
      if (this.form.paId.value !== null) {
        AssociateRepository.GetAllInPa(this.form.paId.value, encodeURIComponent(this.searchValue), this.pageLimit, this.pageIndex)
          .then((res) => {
            this.associados = res.data.content.map((x) => ({'id': x.id, 'nome': x.pessoa.nome, 'numSisbr': x.numSisbr, 'clusterAtual': x.clusterizacaoDTO ? x.clusterizacaoDTO.descricao : ''}))
            this.$refs.AssociatePagination.totalPages = res.data.totalPages
            this.$refs.AssociatePagination.totalElements = res.data.totalElements
            this.$refs.AssociatePagination.numberOfElementsDisplayed = res.data.numberOfElements
            this.$refs.AssociatePagination.offset = res.data.pageable.offset

            loading.pop()
          })
          .catch(this.onException)
      } else {
        loading.pop()
        this.associados = []
        this.selected = []
      }
    },
    openConfirmationModal () {
      this.$nextTick(() => {
        this.$refs['AddConfirmationModal'].showModal()
      })
    }
  }
}
</script>

<style scoped>
  td{
    background-color: whitesmoke;
  }
  .input-group{
    background-color: whitesmoke;
  }
  thead{ position: sticky; top: 0; z-index: 1; }
  v-select{
    border-radius: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/movimentacoes/clusters/link.vue